<template>
  <div class="staking-record-item">
    <van-row class="title">
      <van-col :span="14">
        <span>{{ safeDataitem.order_num }}</span>
      </van-col>
      <van-col :span="10" class="txt-right">
        <span
          v-if="safeDataitem.status != 0"
          :class="safeDataitem.status != 1 ? 'data-down' : 'data-up'"
          >{{
            safeDataitem.status != 1
              ? $t("staking.status2")
              : $t("staking.status1")
          }}</span
        >
        <span
          v-else-if="safeDataitem.status == 0 && safeDataitem.type == 1"
          class="link-btn"
          @click="redeemStaking"
        >
          {{ $t("staking.redeemStaking") }}
        </span>
        <span v-else class="data-up">{{ $t("staking.status0") }}</span>
      </van-col>
      <van-col :span="20"
        >{{ $t("staking.opentime") }} : {{ safeDataitem.addtime }}</van-col
      >
      <van-col :span="4" class="txt-right">{{ safeDataitem.coin }}</van-col>
    </van-row>
    <van-row>
      <van-col :span="12">
        <p>{{ $t("staking.stime") }}</p>
        <span class="data-up">{{ safeDataitem.start_time }}</span>
      </van-col>
      <van-col :span="12" class="txt-right">
        <p>{{ $t("staking.etiem") }}</p>
        <span class="data-down">{{ safeDataitem.end_time }}</span>
      </van-col>
      <van-col :span="8">
        <p>{{ $t("staking.money") }}</p>
        <span>{{ safeDataitem.amount }}</span>
      </van-col>
      <van-col :span="8" class="txt-center">
        <p>{{ $t("staking.days") }}</p>
        <span>{{ safeDataitem.days }} {{ $t("common.day") }}</span>
      </van-col>
      <van-col :span="8" class="txt-right">
        <p>{{ $t("staking.gets") }}</p>
        <span> {{ safeDataitem.total_revenue }} </span>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: "StakingRecordItem",
  props: ["dataitem"],
  computed: {
    safeDataitem() {
      return this.dataitem || {};
    },
  },
  methods:{
    async redeemStaking(){
      await this.$http({
        method: "post",
        url: "redeemStaking",
        data: { id: this.safeDataitem.id },
      }).then((res) => {
        this.$toast.success(res.msg);
        this.$emit('data-refresh');
      });
    }
  }
};
</script>

<style>
</style>
